<div class="dialog-header">
  @if(data.severity == 'info') {
    <div class="dialog-icon-wrapper">
        <div class="dialog-icon new">
        <i class="fa-solid fa-circle-info"></i>
        </div>
        <div>
        <h2 class="dialog-title">Just so you know</h2>
        <p class="dialog-subtitle">Here’s a little extra detail to help you out</p>
        </div>
    </div>
    <button class="dialog-close" (click)="onCancel()">
        <i class="fa-solid fa-xmark"></i>
    </button>
  }
  @if(data.severity == 'error') {
    <div class="dialog-icon-wrapper">
        <div class="dialog-icon new icon-danger-bg">
          <i class="fa-solid fa-triangle-exclamation icon-danger"></i>
        </div>
        <div>
        <h2 class="dialog-title">Oops!!</h2>
        <p class="dialog-subtitle">Something went wrong with your request</p>
        </div>
    </div>
    <button class="dialog-close" (click)="onCancel()">
        <i class="fa-solid fa-xmark"></i>
    </button>
  }

</div>

<mat-dialog-content class="dialog-body">
  <p>{{data.message}}</p>
</mat-dialog-content>

